import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
`;
export const Aviso = styled.span`
    font-size: 20px;
    width:100%;
    text-align: center;
    padding: 15px;
`;

export const Perguntas = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
    padding: 0px 10px;
    flex: auto 1 0;
`;

export const Pergunta = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    border: 1px solid #cecece;
    border-radius: 5px;
    padding: 10px 0px;
    margin: 10px 0px;
    box-shadow: 0px 0px 10px -7px rgba(0,0,0,0.85);
    user-select:none;

    background-color: ${ props => props.respondida ? 'var(--primaryColor)' : '#f9f9f9' };
    flex: auto 1 0;

    ${ props => props.respondida ? `
        color:#fff;
        box-shadow: none;
        border-color: #fff0;
    ` : '' };
    >span {
        font-size: 16px;
        text-align:center;
    }
`;
export const ContainerBtnsResposta = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;

    flex-wrap:wrap;
    gap: 5px;
    width: 100%;
    margin-top: 15px;
    transition-duration: .3s;
    flex: auto 1 0;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`;
export const BtnOpcaoResposta = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 5px 10px;
    background-color: ${ props => props.selected ? 'var(--successColor)' : 'var(--primaryColor)' };
    color: #fff;
    width: 150px;
    text-align:center;
    margin-top: 5px;
    cursor: pointer;
    transition-duration: .3s;
    height: 45px;

    :hover{
        background-color: var(--primaryColorHover);
    }

    :active{
        transform:scale(.9)
    }

    @media (max-width: 768px) {
        margin: 5px 0px;
    }
`;

export const textareaOpcaoResposta = styled.textarea`
    height: 40px;
    width:100%
`;
